/**
 * `SourcePort`（索引 Issue #498 の段階 4）— **外のデータをタイムラインに載せる口**。
 *
 * | メソッド | 中身 |
 * |---|---|
 * | `id()` | ソースの名前（従属オブジェクトの `source.sourceId`） |
 * | `anchors()` | 時刻を持つ点 `[{ key, ms, index, groupId, ordering, payload }]` |
 * | `specs()` | このソースが出す型の宣言（`types.defineType` に渡す形） |
 * | `alignStrategy()` | アンカーの時刻の決め方（名前か `{ resolve }`。省略で `fixed`） |
 * | `states()` | 状態チャンネル（LP・ターン・盤面など。`states.js`） |
 * | `subscribe(fn)` | 中身が変わったら呼ぶ |
 *
 * 実装は再現エンジンのソース（`editorPorts/ocgSource.js`）。**コアはソースが無くても動く**（帯の無いタイムライン）。
 */
import { definePort } from './define';

export const SourcePort = definePort('SourcePort', {
  id: () => 'default',
  anchors: () => [],
  specs: () => [],
  alignStrategy: () => undefined,
  states: () => [],
  subscribe: () => () => {},
});

/** ソース → `createEditor` / `editor.setSource` に渡す形 */
export const sourceOptions = (port) => ({
  anchors: port?.anchors?.() ?? [],
  ctx: { sourceId: port?.id?.() ?? 'default', ...(port?.ctx ?? {}) },
  strategy: port?.alignStrategy?.(),
  states: port?.states?.() ?? [],
});

